type ChimeLogoColor = 'chime_green' | 'primary_neutral';
type ChimeLogoSize = 'small' | 'large';

interface ChimeLogoProps {
  color?: ChimeLogoColor;
  size?: ChimeLogoSize;
  alt: string;
  loading?: 'eager' | 'lazy';
  className?: string;
}

const LOGO_MAP: Record<ChimeLogoColor, Record<ChimeLogoSize, { src: string; width: number; height: number }>> = {
  chime_green: {
    small: { src: '/assets/ck.logo.chime.chime_green.small.registered@3x.png', width: 66, height: 19 },
    large: { src: '/assets/ck.logo.chime.chime_green.large.registered@3x.png', width: 194, height: 56 },
  },
  primary_neutral: {
    small: { src: '/assets/ck.logo.chime.primary_neutral.small.registered@3x.png', width: 66, height: 19 },
    large: { src: '/assets/ck.logo.chime.primary_neutral.large.registered@3x.png', width: 194, height: 56 },
  },
};

const ChimeLogo = ({ color = 'chime_green', size = 'small', alt, loading, className }: ChimeLogoProps) => {
  const { src, width, height } = LOGO_MAP[color][size];
  return <img src={src} alt={alt} width={width} height={height} loading={loading} className={className} />;
};

export default ChimeLogo;
